 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"main": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "bundle-" + ({"ambassador-scss":"ambassador-scss","avenir-scss":"avenir-scss","avenir-v2-scss":"avenir-v2-scss","basic-scss":"basic-scss","cfc-scss":"cfc-scss","cfc-v2-scss":"cfc-v2-scss","conrad-scss":"conrad-scss","europa-scss":"europa-scss","evermore-scss":"evermore-scss","explora-2-scss":"explora-2-scss","explora-scss":"explora-scss","fsy-scss":"fsy-scss","grandhotel-scss":"grandhotel-scss","hicv-scss":"hicv-scss","islamorada-scss":"islamorada-scss","maho-scss":"maho-scss","massanutten-scss":"massanutten-scss","msc-scss":"msc-scss","orient-scss":"orient-scss","pier66-scss":"pier66-scss","prd-scss":"prd-scss","princess-patter-new-scss":"princess-patter-new-scss","princess-patter-scss":"princess-patter-scss","princess-scss":"princess-scss","princess-youth-patter-scss":"princess-youth-patter-scss","ritz-scss":"ritz-scss","saudi-scss":"saudi-scss","sunriver-scss":"sunriver-scss","tauck-scss":"tauck-scss","turnberry-scss":"turnberry-scss","vendors~editor":"vendors~editor","editor":"editor","viva-scss":"viva-scss","vv-2024-09-23-scss":"vv-2024-09-23-scss","vv-scss":"vv-scss","vv2-scss":"vv2-scss","vv3-scss":"vv3-scss","vv4-scss":"vv4-scss","westgate-scss":"westgate-scss"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ambassador-scss":1,"avenir-scss":1,"avenir-v2-scss":1,"basic-scss":1,"cfc-scss":1,"cfc-v2-scss":1,"conrad-scss":1,"europa-scss":1,"evermore-scss":1,"explora-2-scss":1,"explora-scss":1,"fsy-scss":1,"grandhotel-scss":1,"hicv-scss":1,"islamorada-scss":1,"maho-scss":1,"massanutten-scss":1,"msc-scss":1,"orient-scss":1,"pier66-scss":1,"prd-scss":1,"princess-patter-new-scss":1,"princess-patter-scss":1,"princess-scss":1,"princess-youth-patter-scss":1,"ritz-scss":1,"saudi-scss":1,"sunriver-scss":1,"tauck-scss":1,"turnberry-scss":1,"vendors~editor":1,"viva-scss":1,"vv-2024-09-23-scss":1,"vv-scss":1,"vv2-scss":1,"vv3-scss":1,"vv4-scss":1,"westgate-scss":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "styles-" + ({"ambassador-scss":"ambassador-scss","avenir-scss":"avenir-scss","avenir-v2-scss":"avenir-v2-scss","basic-scss":"basic-scss","cfc-scss":"cfc-scss","cfc-v2-scss":"cfc-v2-scss","conrad-scss":"conrad-scss","europa-scss":"europa-scss","evermore-scss":"evermore-scss","explora-2-scss":"explora-2-scss","explora-scss":"explora-scss","fsy-scss":"fsy-scss","grandhotel-scss":"grandhotel-scss","hicv-scss":"hicv-scss","islamorada-scss":"islamorada-scss","maho-scss":"maho-scss","massanutten-scss":"massanutten-scss","msc-scss":"msc-scss","orient-scss":"orient-scss","pier66-scss":"pier66-scss","prd-scss":"prd-scss","princess-patter-new-scss":"princess-patter-new-scss","princess-patter-scss":"princess-patter-scss","princess-scss":"princess-scss","princess-youth-patter-scss":"princess-youth-patter-scss","ritz-scss":"ritz-scss","saudi-scss":"saudi-scss","sunriver-scss":"sunriver-scss","tauck-scss":"tauck-scss","turnberry-scss":"turnberry-scss","vendors~editor":"vendors~editor","editor":"editor","viva-scss":"viva-scss","vv-2024-09-23-scss":"vv-2024-09-23-scss","vv-scss":"vv-scss","vv2-scss":"vv2-scss","vv3-scss":"vv3-scss","vv4-scss":"vv4-scss","westgate-scss":"westgate-scss"}[chunkId]||chunkId) + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "./client/index.tsx");
